// Migration 0047 — /welcome is retired as a standalone surface.
//
// The old one-time welcome-dossier ceremony (Story 3.9) is gone: the free
// dossier is now CLAIMED by the user in the shop (weekly free claim). The
// verify-email handler still 302s to /welcome, so this route stays mounted
// but simply forwards. Keeping the redirect means old links + the
// verify-email 302 never land on a 404.
//
// Signed-in → /shop (where the claim card lives). Signed OUT → `/` (the
// landing with the sign-in card): the verify-email link is usually opened in
// a fresh tab with no session, and dropping that visitor on a signed-out
// /shop stranded them one click after proving their email (staging,
// 2026-08-17).

import { Navigate } from "react-router-dom";

import { useAccountMe } from "../features/admin/useAccountMe";

export function WelcomePage() {
  const session = useAccountMe();

  if (session.isPending) {
    return (
      <main
        className="min-h-screen flex items-center justify-center bg-brand-forest-900 text-brand-paper-100"
        aria-busy="true"
      >
        <div
          className="h-10 w-10 rounded-full border-2 border-brand-gold-300 border-t-transparent animate-spin"
          aria-label="Loading"
        />
      </main>
    );
  }

  const signedIn = Boolean(session.data?.data.user_id);
  return <Navigate to={signedIn ? "/shop" : "/"} replace />;
}
